import Tip from 'assets/Icons/tip';
import Discount from 'assets/Icons/discount';
import styled from 'styled-components';
import { ItemSummaryReport } from './ItemSummaryReport';
import colorTheme from 'constants/color';
import { IStaffPayrollTicketItem } from 'features/report/services/types/reportStaff';
import { formatCurrency } from 'utils/formatCurrency';
import TotalSale from 'assets/Icons/totalSale';
import Receipt from 'assets/Icons/receipt';

const sum = (
  data: IStaffPayrollTicketItem[] | undefined,
  picker: (i: IStaffPayrollTicketItem) => number,
) => data?.reduce((s, i) => s + picker(i), 0) ?? 0;


interface IDetailSummaryReportProps {
    data?: IStaffPayrollTicketItem[]
}

const DetailSummaryReport = ({ data }: IDetailSummaryReportProps) => {
  return (
    <Container>
      <ItemSummaryReport
        label="Net Sale"
        value={formatCurrency(sum(data, i => i.netSaleSalary))}
        valueColor="#DA072D"
        icon={<TotalSale width={40} height={40} fill={colorTheme.v2_other_3} />}
      />

      <ItemSummaryReport
        label="Sale Service"
        value={formatCurrency(sum(data, i => i.saleService))}
        icon={<Tip width={40} height={40} />}
      />

      <ItemSummaryReport
        label="Sale Product"
        value={formatCurrency(sum(data, i => i.saleProduct))}
        icon={<Tip width={40} height={40} fill={colorTheme.v2_green_4} />}
      />

      <ItemSummaryReport
        label="Supply Fee"
        value={formatCurrency(sum(data, i => i.supplyFee))}
        icon={<Receipt width={40} height={40} fill={colorTheme.v2_purple_4} />}
      />

      <ItemSummaryReport
        label="Discount"
        value={formatCurrency(sum(data, i => i.discount))}
        icon={<Discount width={40} height={40} />}
      />

      <ItemSummaryReport
        label="Tip"
        value={formatCurrency(sum(data, i => i.tip))}
        valueColor={colorTheme.v2_green_8}
        icon={<Tip width={40} height={40} fill={colorTheme.v2_green_8} />}
      />
    </Container>
  );
};

export default DetailSummaryReport;

const Container = styled.div`
  display: flex;
  gap: 8px;
`;
